const removeSelectedOptionFromOtherSelects = (selectedOption, previousOption, changedSelect) => {
  $('.mosaic-customize-select2').each(function() {
    const input = $(this)
    if (input.attr('id') === changedSelect.attr('id')) return

    if (previousOption.id !== '') {
      input.find(`option[value="${previousOption.id}"]`).prop('disabled', false)
    }

    if (selectedOption.id !== '') {
      input.find(`option[value="${selectedOption.id}"]`).prop('disabled', true)
    }
  })
}

$(() => {
  const previousDataMap = {}

  $('.mosaic-customize-select2').select2({ language: 'it', width: '80%' })
  
  $('.mosaic-customize-select2').each(function() {
    const input = $(this)

    const selectedOption = input.select2('data')[0]
    if (selectedOption && selectedOption.id !== '') {
      removeSelectedOptionFromOtherSelects(selectedOption, {}, input)
    }

    input.on('select2:selecting', () => {
      previousDataMap[input.attr('id')] = input.select2('data')[0]
    })

    input.on('select2:select', event => {
      removeSelectedOptionFromOtherSelects(event.params.data, previousDataMap[input.attr('id')], input)
    })
  })
})
